import { useState } from 'react';
import withWaymarkModal from 'shared/components/WithWaymarkModal';
import { AuthFormView } from './types';
import AuthForm from './index';

interface AuthModalContentsProps {
  defaultFormView?: AuthFormView;
  onCloseModal: () => void;
  onLoginSuccess?: () => void;
}

/**
 *  Renders the contents of the auth modal
 * @param {AuthFormView} defaultFormView - The initial view to show in the auth form  (defaults to login)
 * @param {function} onCloseModal - Closes the modal
 * @param {function} [onLoginSuccess] - Callback which is run after succesful login / signup
 */
function AuthModalContents({
  defaultFormView = AuthFormView.Login,
  onCloseModal,
  onLoginSuccess = undefined,
}: AuthModalContentsProps) {
  const [formView, setFormView] = useState(defaultFormView);

  return (
    <AuthForm
      formView={formView}
      onChangeFormView={setFormView}
      onLoginSuccess={() => {
        onLoginSuccess?.();
        onCloseModal();
      }}
      preferVerticalLayout
    />
  );
}

const AuthModal = withWaymarkModal()(AuthModalContents);
export default AuthModal;
